export default "__VITE_ASSET___pN8atlQ__"